import BaseFormPresenter from "../../components/common/BaseFormPresenter";
import { recordSignOutAudit } from "../../usecases/logs";
import {
  deleteObjectUseCase,
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../usecases/object";
import { getCurrentUserUseCase } from "../../usecases/user";
import { _convertSetupHolderToObject } from "../../SetupHolder";

/**
 * responsible for get the current user and current roles and schemas
 */
class MainPagePresenter extends BaseFormPresenter {
  constructor(
    view,
    getCurrentUserUseCase,
    signOutUseCase,
    getSchemaUseCase,
    // liveQueryNanager,
  ) {
    super(view);
    this.view = view;
    this.getCurrentUserUseCase = getCurrentUserUseCase;
    this.signOutUseCase = signOutUseCase;
    this.getSchemaUseCase = getSchemaUseCase;
    // this.liveQueryManager = liveQueryNanager;
  }

  async componentDidMount() {
    await this.init();

    // try {
    //   // await this.employeeMonthlyEarning();
    //   await this._getPayrollSetupHolder();
    // } catch (e) {
    //   console.error("Error in employeeMonthlyEarning: ", e.message || e);
    // }
  }

  // test

  async onInactivityLogout() {
    try {
      await recordSignOutAudit();
      await this.signOutUseCase.execute().finally(() => {
        this.view.navigateTo("/signin");
        this.view.showError(
          "You have been logged out due to inactivity.",
          "Session Expired",
        );
      });
    } catch (e) {
      console.error("Inactivity error: ", e.message || e);
    }
  }

  // computeCreditAddtion(recordLength) {
  //   let conversionValue = 0.042;
  //   for (let i = 1; i <= recordLength; i++) {
  //     // Reset the conversion value at the start of each 30-day cycle
  //     if ((i - 1) % 30 === 0) {
  //       conversionValue = 0.042; // Reset conversionValue to 0.042 at the start of each cycle
  //     } else if (i % 30 === 2) {
  //       conversionValue += 0.041; // Add 0.041 for the second day of each cycle
  //     } else if (((i % 30) - 2) % 3 === 1 || ((i % 30) - 2) % 3 === 2) {
  //       conversionValue += 0.042; // Add 0.042 on the 3rd, 4th, 6th, 7th, etc., within each cycle
  //     } else {
  //       conversionValue += 0.041; // Add 0.041 on the 5th, 8th, etc., within each cycle
  //     }
  //   }
  //   if (recordLength === 30) {
  //     return (1.25).toFixed(3);
  //   } else {
  //     const total = conversionValue;
  //     return total.toFixed(3);
  //   }
  // }

  // async processLeave(type, leaveCredit, creditAmount, employee) {
  //   const leaveExists = leaveCredit.find((leave) => leave.type === type);

  //   const today = new Date();

  //   // Get the first day of the previous month
  //   const startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);

  //   // Get the last day of the previous month
  //   const endDate = new Date(today.getFullYear(), today.getMonth(), 0); // Day 0 of current month = last day of prev

  //   const generateLeaveCard = {
  //     employee: { id: employee.id },
  //     leaveType: type,
  //     earned: creditAmount,
  //     startDate: startDate.toISOString(),
  //     endDate: endDate.toISOString(),
  //   };

  //   // Add leave if it doesn't exist
  //   if (!leaveExists) {
  //     const newLeave = {
  //       type,
  //       current: creditAmount,
  //       email: employee.email,
  //       empID: employee.id,
  //     };

  //     try {
  //       generateLeaveCard.balance = newLeave.current;
  //       await upsertUseCase().execute("leave_card", generateLeaveCard);
  //     } catch (e) {
  //       console.error("E: ", e.message || e);
  //     }

  //     return newLeave;
  //   } else {
  //     // Increment leave if it exists
  //     leaveExists.empID = employee.id;
  //     leaveExists.current = (
  //       parseFloat(leaveExists.current) + parseFloat(creditAmount)
  //     ).toFixed(3);

  //     try {
  //       generateLeaveCard.balance = leaveExists.current;
  //       console.log("ExistsLeave :  ", generateLeaveCard);
  //       await upsertUseCase().execute("leave_card", generateLeaveCard);
  //     } catch (e) {
  //       console.error("E: ", e);
  //     }

  //     return leaveExists;
  //   }
  // }

  // async employeeMonthlyEarning() {
  //   const currentDate = new Date();
  //   const currentUser = await getCurrentUserUseCase().execute();
  //   const isMaster =
  //     currentUser.employee.id === "8041edc5-ab5c-436f-8852-64ce06653c8b";

  //   if (!isMaster) return;

  //   // DAY 1
  //   if (currentDate.getDate() === 1) {
  //     try {
  //       const listOfEmployees = await findObjectUseCase().execute("employees", {
  //         // limit: 25,
  //         where: { isMonthCredAdded: "no" },
  //         keys: ["isMonthCredAdded", "isEmpNewlyHired", "hired", "email"],
  //       });
  //       console.log("LIST: ", listOfEmployees);

  //       for (const employee of listOfEmployees) {
  //         console.log("credit_added");
  //         const leaveCredit = await findObjectUseCase().execute("leave_cred", {
  //           where: {
  //             empID: employee.id,
  //             type: { $in: ["Sick Leave", "Vacation Leave"] },
  //           },
  //           keys: ["type", "empID", "current"],
  //         });

  //         // check if employee Newly Hired
  //         let creditFirstMonthHired = (1.25).toFixed(3); // Default credit amount
  //         if (employee.isEmpNewlyHired === "yes") {
  //           const dateHired = new Date(employee?.hired);
  //           const dateToDay = new Date();
  //           if (
  //             dateHired.getMonth() + 1 === dateToDay.getMonth() &&
  //             dateHired.getFullYear() === dateToDay.getFullYear()
  //           ) {
  //             const dateGap = Math.abs(31 - dateHired.getDate());
  //             creditFirstMonthHired = this.computeCreditAddtion(dateGap);
  //           }
  //         }

  //         // Process Sick Leave
  //         const sickLeave = await this.processLeave(
  //           "Sick Leave",
  //           leaveCredit,
  //           creditFirstMonthHired,
  //           employee
  //         );
  //         // Process Vacation Leave
  //         const vacationLeave = await this.processLeave(
  //           "Vacation Leave",
  //           leaveCredit,
  //           creditFirstMonthHired,
  //           employee
  //         );

  //         // console.log("VAcation:  ", vacationLeave);
  //         // console.log("SICKLEave:  ", sickLeave);
  //         // Save or update leave credits to the database
  //         try {
  //           await upsertUseCase().execute("leave_cred", sickLeave);
  //           await upsertUseCase().execute("leave_cred", vacationLeave);
  //           // Update the employee's monthly credit status
  //           const data = {
  //             id: employee.id,
  //             isEmpNewlyHired: "no",
  //             isMonthCredAdded: "yes",
  //           };
  //           await upsertUseCase().execute("employees", data);
  //         } catch (e) {
  //           console.error("Leave: ", e);
  //         }
  //       }
  //     } catch (e) {
  //       console.error("monthlyEarning: ", e.message || e);
  //     }
  //   }

  //   // DAY 2
  //   if (currentDate.getDate() === 2) {
  //     try {
  //       const listOfEmployees = await findObjectUseCase().execute("employees", {
  //         where: { isMonthCredAdded: "yes" },
  //         keys: ["isMonthCredAdded"],
  //       });

  //       console.log("LIST: ", listOfEmployees);

  //       for (const employee of listOfEmployees) {
  //         console.log("update_monthly_status");
  //         const data = {
  //           id: employee.id,
  //           isMonthCredAdded: "no",
  //         };
  //         await upsertUseCase().execute("employees", data);
  //       }
  //     } catch (e) {
  //       console.error("MainPagePresenter", e);
  //     }
  //   }
  // }

  async init() {
    this.view.showProgress();

    try {
      await this.getUser();
      await this.getSchema();
      this.view.hideProgress();
    } catch (error) {
      this.view.hideProgress();
      switch (error.code) {
        case 401:
          this.view.navigateTo("/signin");
          break;
        case 403:
          this.view.navigateTo("/app");
          break;
        default:
          this.view.showError(error);
      }
    }
  }

  async getUser() {
    try {
      const user = await this.getCurrentUserUseCase.execute();
      this.user = user;
      if ((!user.roles || user.roles.length === 0) && !this.user.isMaster) {
        this.view.navigateTo("/denied");
        return;
      }
      if (user.status === "inactive") {
        this.showError("Account Disabled");
        this.view.navigateTo("/signin");
        return;
      }

      try {
        const records = await getObjectUseCase().execute("users", user?.id, {
          params: {
            keys: [
              ...this.view.orgFields,
              "employee.position.position_title",
              "employee.Firstname",
              "employee.Middlename",
              "employee.surname",
              "isReset",
              "roles",
            ],
            include: ["roles", "employee", "employee.position"],
          },
        });
console.log("RECORDS: ", records);
        if (!records || !records.employee) {
          this.showError("User data not found. Please contact administrator.");
          localStorage.clear();
          this.view.navigateTo("/signin");
          return;
        }

        const lastNoneEmptyValue = this.view.getLastNonEmptyField(
          records.employee,
        );

        let division = {};
        if (lastNoneEmptyValue.result !== "") {
          division = await getObjectUseCase().execute(
            this.view.orgCollection[lastNoneEmptyValue.index],
            lastNoneEmptyValue?.result,
            {
              params: {
                select: ["name"],
              },
            },
          );
        }

        const userRoles = records.roles.flatMap(
          (item) => item.rolePermission || [],
        );
        const uniqueMenus = userRoles.filter(
          (menu, index, self) =>
            index === self.findIndex((m) => m.name === menu.name),
        );

        this.view.setCurrentRoles(user.roles || []);
        this.view.setCurrentUser(user);
        await this.view.setPermissions(uniqueMenus, records.employee, division);
        if (records.isReset === false || !records.isReset) {
          this.view.requirePasswordReset();
        }
      } catch (error) {
        // console.error("Error setting permissions:", error);
        this.showError(error);
      }
    } catch (error) {
      throw error;
    }
  }

  async getSchema() {
    try {
      const schemas = await this.getSchemaUseCase.execute();
      this.view.setSchemas(schemas);
    } catch (error) {
      throw error;
    }
  }

  onClickSignOut() {
    const options = {
      title: "Confirm",
      message: "Are you sure you want to sign out?",
      positiveButton: "SIGN OUT",
    };

    this.view
      .showDialog(options)
      .then(async () => {
        await recordSignOutAudit();
        await this.signOutUseCase.execute();
      })
      .then(() => {
        localStorage.clear();
        this.view.navigateTo("/signin");
      })
      .catch((error) => {
        this.view.showError(error);
      });
  }
}

export default MainPagePresenter;
